module.exports = __webpack_public_path__ + "static/media/TREE.89b9ac03.png";